module.exports = __webpack_public_path__ + "img/logo.66bd57c6.png";